import { CustomField } from "@/backend/models/customFields/customField";
import { I18n } from "@/i18n/I18n";
import { FileTypes } from "@/types/fileTypes";
import { FileWithDisplay } from "./FileWithDisplay";

export function FileRunView(props: { customField: CustomField, hideFilePreview?: boolean }) {
  const { customField, hideFilePreview } = props;
  if (!customField.file) {
    return <div>{I18n.get('noFileUploaded')}</div>;
  }

  const { file } = customField;

  if (customField.file.type !== FileTypes.IMAGE && customField.file.type !== FileTypes.VIDEO) {
    return <div className='d-flex flex-column gap-1'>{file.fileName}</div>;
  }

  return <FileWithDisplay file={file} hideFilePreview={hideFilePreview} />;
}